import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { DashboardData } from '../../types/types';
import dataService from '../../data/dataService';
import '../../styles/Admin.css';

const Dashboard: React.FC = () => {
  const [data, setData] = useState<DashboardData | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    dataService.getDashboard().then(setData).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="admin-page"><p>Loading dashboard...</p></div>;
  if (!data) return <div className="admin-page"><p>Failed to load dashboard.</p></div>;

  return (
    <div className="admin-page">
      <div className="admin-header">
        <h1>Admin Dashboard</h1>
        <nav className="admin-nav">
          <Link to="/admin/orders">Orders</Link>
          <Link to="/admin/products">Products</Link>
          <Link to="/admin/reviews">Reviews</Link>
          <Link to="/admin/discounts">Discounts</Link>
          <Link to="/admin/agent-dashboard">Agent Demo</Link>
        </nav>
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <span className="stat-label">Total Orders</span>
          <span className="stat-value">{data.totalOrders}</span>
        </div>
        <div className="stat-card">
          <span className="stat-label">Revenue</span>
          <span className="stat-value">${data.totalRevenue.toFixed(2)}</span>
        </div>
        <div className="stat-card">
          <span className="stat-label">Pending Orders</span>
          <span className="stat-value">{data.pendingOrders}</span>
        </div>
        <div className="stat-card">
          <span className="stat-label">Products</span>
          <span className="stat-value">{data.totalProducts}</span>
        </div>
        <div className="stat-card">
          <span className="stat-label">Users</span>
          <span className="stat-value">{data.totalUsers}</span>
        </div>
      </div>

      <div className="admin-section">
        <h2>Top Products</h2>
        {data.topProducts.length === 0 ? <p>No orders yet.</p> : (
          <table className="admin-table">
            <thead><tr><th>Product</th><th>Sold</th><th>Revenue</th></tr></thead>
            <tbody>
              {data.topProducts.map(p => (
                <tr key={p.productId}>
                  <td>{p.productName}</td>
                  <td>{p.totalQuantity}</td>
                  <td>${p.totalRevenue.toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      <div className="admin-section">
        <h2>Recent Orders</h2>
        {data.recentOrders.length === 0 ? <p>No orders yet.</p> : (
          <table className="admin-table">
            <thead><tr><th>ID</th><th>Customer</th><th>Total</th><th>Status</th><th>Date</th></tr></thead>
            <tbody>
              {data.recentOrders.map(o => (
                <tr key={o.id}>
                  <td>#{o.id}</td>
                  <td>{o.userName}</td>
                  <td>${o.total.toFixed(2)}</td>
                  <td><span className={`order-status status-${o.status.toLowerCase()}`}>{o.status}</span></td>
                  <td>{new Date(o.createdAt).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
